import { render } from "./Impressum.vue?vue&type=template&id=aa78c796&ts=true"
import script from "./Impressum.vue?vue&type=script&lang=ts"
export * from "./Impressum.vue?vue&type=script&lang=ts"

import exportComponent from "/home/tristobombo/PHPStormProjects/ITW-webapp-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__